import { INavigationCategory, INavigationLink } from "../interfaces/INavigation";

import { 
    Dashboard as DashboardIcon,
    Settings,
    Security,
    Fingerprint,
    People,
    Business,
    Dvr,
    Description,
    Analytics,
    DryCleaning
} from '@mui/icons-material';
import Start from "../pages/Admin/Start";
import Dashboard from "../pages/Admin/Governance/Dashboard";
import AccessProfile from "../pages/Admin/Administrative/AccessProfile";
import User from "../pages/Admin/Administrative/User";
import Enterprise from "../pages/Admin/Administrative/Enterprise";
import SystemSettings from "../pages/Admin/Administrative/SystemSettings";
import RoomOverview from "../pages/Admin/Governance/RoomOverview";
import Reports from "../pages/Admin/Governance/Reports";
import AnalyticalDashboard from "../pages/Admin/Analytics/AnalyticalDashboard";
import GovernanceItem from "../pages/Admin/Administrative/GovernanceItem";
import RoomBlocking from "../pages/Admin/Governance/RoomBlocking";
import { RoomStatusData, RoomStatusEnum } from "./Enums";


const StartLink: INavigationLink = {
    alias: [],
    name: 'start',
    description: undefined,
    Icon: null,
    Component: Start,
    items: null
};

const Navigation: INavigationCategory[] = [
    
    // Governance
    {
        title: 'governanceModuleName',
        alias: ['Governance.Dashboard', 'Governance.RoomOverview', 'Governance.RoomBlocking', 'Governance.Reports'],
        items: [
            {
                alias: ['Governance.Dashboard'],
                name: 'dashboard',
                description: undefined,
                Icon: DashboardIcon,
                Component: Dashboard,
                items: null
            }, {
                alias: ['Governance.RoomOverview'],
                name: 'roomOverview',
                description: undefined,
                Icon: Dvr,
                Component: RoomOverview,
                items: null
            }, {
                alias: ['Governance.RoomBlocking'],
                name: 'roomBlocking',
                description: undefined,
                Icon: RoomStatusData[RoomStatusEnum.RoomBlocking].Icon,
                Component: RoomBlocking,
                items: null
            }, {
                alias: ['Governance.Reports'],
                name: 'reports',
                description: undefined,
                Icon: Description,
                Component: Reports,
                items: null
            }
        ]
    },


    // Analytics
    {
        title: 'analyticsModuleName',
        alias: ['Analytics.AnalyticalDashboard'],
        items: [
            {
                alias: ['Analytics.AnalyticalDashboard'],
                name: 'analyticalDashboard',
                description: undefined,
                Icon: Analytics,
                Component: AnalyticalDashboard,
                items: null
            }
        ]
    },


    // Administrative
    {
        title: 'administrativeModuleName',
        alias: ['Administrative.Enterprises', 'Administrative.AccessProfiles', 'Administrative.Users', 'Administrative.GovernanceItems', 'Administrative.Settings'],
        items: [
            {
                name: 'accessControl',
                description: undefined,
                Icon: Security,
                Component: () => null,
                alias: ['Administrative.Enterprises', 'Administrative.AccessProfiles', 'Administrative.Users'],
                items: [
                    {
                        alias: ['Administrative.Enterprises'],
                        name: 'enterprises',
                        description: undefined,
                        Icon: Business,
                        Component: Enterprise,
                        items: null
                    }, {
                        alias: ['Administrative.AccessProfiles'],
                        name: 'accessProfiles',
                        description: undefined,
                        Icon: Fingerprint,
                        Component: AccessProfile,
                        items: null
                    }, {
                        alias: ['Administrative.Users'],
                        name: 'users',
                        description: undefined,
                        Icon: People,
                        Component: User,
                        items: null
                    }
                ]
            }, {
                alias: ['Administrative.GovernanceItems'],
                name: 'governanceItems',
                description: undefined,
                Icon: DryCleaning,
                Component: GovernanceItem,
                items: null
            }, {
                alias: ['Administrative.Settings'],
                name: 'settings',
                description: undefined,
                Icon: Settings,
                Component: SystemSettings,
                items: null
            }, 
        ]
    },
];



export {
    StartLink
}

export default Navigation;